import Verification from './components/Verification';

export const verification = {
  firstLevel: Verification,
};